var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader',{attrs:{"title":"비밀번호 찾기","is-history":""}}),_c('AppContent',[_c('FindPasswordDetail')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }